export const STORE_ACTIVE_STATUS = 1;

export const GENERIC_CATEGORY = "Otros";
